import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import UserClasses from '../users/Users.module.css';
import Layout from 'Components/Layout';
import { Helmet } from 'react-helmet';
import CategoryClasses from '../categories/AddCategory.module.css';
import { Services } from 'Services';
import { useNavigate } from 'react-router-dom';
import { Success, Error } from 'Util/Toast';
import { Button } from '@mui/material';
import CommonCategoryClasses from '../commoncssfiles/CategoryCommon.module.css';
import CommonTutorClasses from '../commoncssfiles/CategoryTutor.module.css';
import { BsCloudUpload } from 'react-icons/bs';
import ReactLoading from 'react-loading';
import ProductClasses from '../products/Products.module.css';

const AddBanner = () => {
    const navigate = useNavigate();
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const [imagePreview, setImagePreview] = useState('');
    const [loading, setLoading] = useState(false);
    const [uploadedFileName, setUploadedFileName] = useState(''); 

    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const allowedTypes = ["image/png", "image/jpeg", "image/webp"];
        if (!allowedTypes.includes(file.type)) {
            Error(`${file.name} is not a valid image format.`);
            return;
        }

        let formData = new FormData();
        formData.append("image", file);
        formData.append("folder", "banners");

        try {
            setLoading(true);
            const res = await Services.UploadImage(formData);
            if (res?.Status === 1) {
                const uploadedUrl = res?.ImageURL; // Changed from fileUrl to ImageURL
                setUploadedFileName(res?.ImageID); // Changed from fileName to ImageID
                setImagePreview(uploadedUrl || URL.createObjectURL(file));
                setValue('imageUrl', res?.ImageID); // Changed from fileName to ImageID
                setLoading(false);
            } else {
                Error(res?.Message || "Upload failed.");
                setLoading(false);
            }
        } catch (err) {
            console.error("Upload Error:", err);
            Error("Upload error. Please try again.");
            setLoading(false);
        }
    };

    const onSubmit = async (data) => {
        console.log('Form submitted with data:', data); // Debug log
        console.log('Uploaded file name:', uploadedFileName); // Debug log
        
        if (!uploadedFileName) {
            Error('Please upload an image.');
            return;
        }

        setLoading(true);

        const requestBody = {
            bannerName: data.bannerName,
            imageUrl: uploadedFileName, // Use the uploaded file name
            priority: parseInt(data.priority),
        };

        console.log('Request body:', requestBody); // Debug log

        const token = { Authorization: `token ${localStorage.getItem('Token')}` };

        try {
            const response = await Services.addBanner(requestBody, token);
            console.log('API Response:', response); // Debug log
            
            if (response.Status === 1) {
                navigate('/banners');
                Success(response.Message);
                console.log('Banner added successfully:', response.Message);
            } else {
                Error(response.Message);
                console.error('Error adding banner:', response.Message);
            }
        } catch (error) {
            console.error('Error adding banner:', error);
            Error('Error adding banner');
        } finally {
            setLoading(false);
        }
    };

    const fileuploadDesign = (
        <div className={CommonTutorClasses["add-item"]} onClick={() => document.getElementById("image").click()}>
            <div className={CommonTutorClasses['upload-image']}>
                {imagePreview && <img src={imagePreview} alt="Selected" className={CommonTutorClasses['uploaded-coupon-image']} />}
                {loading && <ReactLoading className={ProductClasses['loading-spinner-container']} type="spin" color="#000" height={50} width={50} />}
                {!imagePreview && (
                    <div className={CommonTutorClasses['add-item']}>
                        <BsCloudUpload className={CommonTutorClasses['upload-icon']} />
                        <h5>Drag Your Files here</h5>
                        <p>(Only *.jpeg, *.png, *.webp will be accepted)</p>
                    </div>
                )}
                <input type="file" id="image" onChange={handleImageUpload} style={{ display: 'none' }} />
            </div>
        </div>
    );

    return (
        <Layout Active={'Banners'}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Create Banner</title>
            </Helmet>
            <div className={UserClasses['main-first-container']}>
                <div className={UserClasses['main-data-tab']}>
                    <div className={UserClasses['add-users-btn']}>
                        <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                            BACK
                        </Button>
                    </div>
                    <div className={CommonTutorClasses['wrapper']} data-aos="zoom-in-down">
                        <h2 className={CommonTutorClasses['main-header']}>Create Banner</h2>
                        <form style={{display: 'block'}} className={CommonTutorClasses["form"]} onSubmit={handleSubmit(onSubmit)}>
                            <div style={{marginBottom: '10px'}} className={CommonTutorClasses['form-control']}>
                                <label htmlFor="bannerName">Banner Name</label>
                                <input 
                                    style={{width: '97%'}} 
                                    type='text' 
                                    id="bannerName"
                                    {...register('bannerName', { required: 'Banner name is required' })} 
                                />
                                {errors.bannerName && <p className={CategoryClasses["error-text"]}>{errors.bannerName.message}</p>}
                            </div>
                            <div style={{marginBottom: '10px'}} className={CommonTutorClasses['form-control']}>
                                <label htmlFor="priority">Priority</label>
                                <input
                                    style={{width: '97%'}}
                                    type='number'
                                    id="priority"
                                    {...register('priority', { required: 'Priority is required', valueAsNumber: true })}
                                />
                                {errors.priority && <p className={CategoryClasses["error-text"]}>{errors.priority.message}</p>}
                            </div>
                            <div className={CommonTutorClasses['file-upload-wrapper']}>
                                <header>
                                    <h3>
                                        Upload Banner Image <span className="important">*</span>
                                    </h3>
                                </header>
                                <div className={CommonTutorClasses["upload-image"]}>
                                    {fileuploadDesign}
                                </div>
                                {!uploadedFileName && <p className="error-message">Please upload a Banner image.</p>}
                            </div>
                            <div className={ProductClasses['form-btn-main']}>
                                <Button 
                                    style={{marginTop: '10px'}} 
                                    type="submit" 
                                    variant="contained"
                                    disabled={loading}
                                    onClick={(e) => {
                                        console.log('Button clicked'); // Debug log
                                        // Let the form handle the submission
                                    }}
                                >
                                    {loading ? 'Adding Banner...' : 'Add Banner'}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default AddBanner;